const formatWeight = (weight) => `${weight.toFixed(3).replace('.', ',')} kg`;

export default formatWeight;
